import { DeckProps } from "@deck.gl/core";
import { MapboxOverlay, MapboxOverlayProps } from "@deck.gl/mapbox";
import { useControl } from "react-map-gl/mapbox";

import { hotfixLumaDeviceProps } from "@/lib/mapbox/deck-mapbox-luma-device-props";

export function DeckGLOverlay(props: DeckProps & MapboxOverlayProps) {
  if (!("deviceProps" in props)) {
    props = { ...props, deviceProps: hotfixLumaDeviceProps };
  }
  const overlay = useControl(() => new MapboxOverlay(props));
  overlay.setProps(props);
  return null;
}
